function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.251 13.416h-10.5A1.784 1.784 0 0 1 0 11.6V9.727a1.785 1.785 0 0 1 1.751-1.818h10.5A1.785 1.785 0 0 1 14 9.727V11.6a1.784 1.784 0 0 1-1.749 1.818Zm0-7.324h-10.5A1.786 1.786 0 0 1 0 4.274V2.4A1.785 1.785 0 0 1 1.751.584h10.5A1.785 1.785 0 0 1 14 2.4v1.874a1.785 1.785 0 0 1-1.749 1.818Zm0-3.69h-10.5v1.872h10.5V2.4Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/goals.a24a5b9c.svg";
export { SvgComponent as ReactComponent };